import { render, staticRenderFns } from "./formularyAxess.vue?vue&type=template&id=012b424e&scoped=true&"
import script from "./formularyAxess.vue?vue&type=script&lang=js&"
export * from "./formularyAxess.vue?vue&type=script&lang=js&"
import style0 from "./formularyAxess.vue?vue&type=style&index=0&id=012b424e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b424e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDivider,VRow,VTextField})
